module.exports = __webpack_public_path__ + "static/media/Eraser__Curriculum.1104fba4.svg";